import React, { useMemo } from 'react';
import { SentryContext } from './SentryContext';
import { Sentry } from './index';

export default ({
  children,
  showErrorDetails = false,
  enabled,
  dsn,
  environment,
  release,
  sampleRate,
  tracesSampleRate,
  tracePropagationTargets,
}) => {
  useMemo(() => {
    if (enabled) {
      Sentry.init({
        dsn,
        environment,
        release,
        sampleRate,
        tracesSampleRate,
        tracePropagationTargets,
      });
    }
  }, []);
  return (
    <SentryContext.Provider
      value={{
        showSidePageErrorDetail: showErrorDetails,
        showChartErrorDetails: showErrorDetails,
        showRouteErrorDetails: showErrorDetails,
      }}
    >
      {children}
    </SentryContext.Provider>
  );
};
